// extracted by mini-css-extract-plugin
module.exports = {"footer":"EmbedWrapper_footer__1E_6Y","logo":"EmbedWrapper_logo__3Yt4f","buttonWrap":"EmbedWrapper_buttonWrap__1k6iR","button":"EmbedWrapper_button__2ufKt"};